/* eslint-disable func-style */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
import type { ObjectDirective } from 'vue'

interface HoverZIndexElement extends HTMLElement {
  _hoverzOriginalZIndex?: string
  _hoverzOriginalPosition?: string
  _hoverZIndexHandlers?: {
    onMouseEnter: (event: MouseEvent) => void
    onMouseLeave: (event: MouseEvent) => void
  }
}

const hoverZIndexDirective: ObjectDirective<
  HoverZIndexElement,
  number | undefined
> = {
  bind(_element, _binding) {},

  inserted(element, binding) {
    const hoverZ = binding.value ?? 9999

    const style = window.getComputedStyle(element)

    element._hoverzOriginalZIndex = style.zIndex === 'auto' ? '' : style.zIndex

    if (style.position === 'static') {
      element._hoverzOriginalPosition = 'static'
      element.style.position = 'relative'
    }

    const onMouseEnter = () => {
      element.style.zIndex = hoverZ.toString()
    }
    const onMouseLeave = () => {
      element.style.zIndex = element._hoverzOriginalZIndex || ''
    }

    element._hoverZIndexHandlers = { onMouseEnter, onMouseLeave }

    element.addEventListener('mouseenter', onMouseEnter)
    element.addEventListener('mouseleave', onMouseLeave)
  },

  update(element, binding) {
    const hoverZ = binding.value ?? 9999
    if (element._hoverZIndexHandlers) {
      element._hoverZIndexHandlers.onMouseEnter = () => {
        element.style.zIndex = hoverZ.toString()
      }
    }
  },

  componentUpdated(_element, _binding) {},

  unbind(element) {
    if (element._hoverZIndexHandlers) {
      element.removeEventListener(
        'mouseenter',
        element._hoverZIndexHandlers.onMouseEnter,
      )
      element.removeEventListener(
        'mouseleave',
        element._hoverZIndexHandlers.onMouseLeave,
      )
      delete element._hoverZIndexHandlers
    }

    if (element._hoverzOriginalPosition === 'static') {
      element.style.position = 'static'
      delete element._hoverzOriginalPosition
    }
  },
}

export default hoverZIndexDirective
